module.exports = "/images/assingOrder.svg";